export interface Notification {
    id: string;
    user_id: string;
    type: NotificationType;
    title: string;
    message: string;
    link?: string;
    is_read: boolean;
    created_at: string;
}

export type NotificationType =
    | 'document_expiring'
    | 'document_expired'
    | 'renewal_uploaded'
    | 'renewal_approved'
    | 'renewal_rejected'
    | 'checklist_assigned'
    | 'checklist_step_due'
    | 'checklist_nudge'
    | 'policy_assigned'
    | 'training_assigned'
    | 'access_review_due'
    | 'compliance_item_due';

export interface NotificationListResponse {
    data: Notification[];
    total_count: number;
    page: number;
    page_size: number;
    has_more: boolean;
}

export interface UnreadCountResponse {
    count: number;
}

/** Maps notification types to icon names and colors */
export const NOTIFICATION_META: Record<NotificationType, { icon: string; color: string }> = {
    document_expiring:  { icon: '📄', color: '#F59E0B' },
    document_expired:   { icon: '⚠️', color: '#EF4444' },
    renewal_uploaded:   { icon: '📤', color: '#3B82F6' },
    renewal_approved:   { icon: '✅', color: '#10B981' },
    renewal_rejected:   { icon: '❌', color: '#EF4444' },
    checklist_assigned: { icon: '📋', color: '#8B5CF6' },
    checklist_step_due: { icon: '⏰', color: '#F59E0B' },
    checklist_nudge:    { icon: '👋', color: '#6366F1' },
    policy_assigned:    { icon: '📜', color: '#0EA5E9' },
    training_assigned:  { icon: '🎓', color: '#14B8A6' },
    access_review_due:  { icon: '🔑', color: '#F97316' },
    compliance_item_due:{ icon: '📊', color: '#EC4899' },
};
